import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

export const StyledDismiss = styled.div`
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

export const StyledProviderLogo = styled.img`
  height: 2rem;
  width: 2rem;
  margin-right: 0.8rem;
  position: relative;
  bottom: 0.1rem;
`;

export const StyledSyncTeamsCTA = styled.div`
  margin: 1rem;
  padding: 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: ${getColor('feta')};
  font-size: 1.3rem;
  & > .primary {
    font-weight: bold;
    margin-right: 1rem;
  }
  & > .secondary {
    margin-right: 1rem;
  }
  & ${StyledDismiss} {
    margin-left: auto;
  }
`;
